import { render, staticRenderFns } from "./OutgoingDetails.vue?vue&type=template&id=5ed57e8e&scoped=true&"
import script from "./OutgoingDetails.vue?vue&type=script&lang=js&"
export * from "./OutgoingDetails.vue?vue&type=script&lang=js&"
import style0 from "./OutgoingDetails.vue?vue&type=style&index=0&id=5ed57e8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed57e8e",
  null
  
)

export default component.exports